// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReviewForm_item__rJ7W6 {
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.0509803922);
  background-color: var(--white);
  border-radius: 12px;
}

.ReviewForm_main__K0R6V {
  padding: 8px;
}
@media (min-width: 640px) {
  .ReviewForm_main__K0R6V {
    padding: 12px;
  }
}

.ReviewForm_header__xiVcp {
  padding-bottom: 4px;
}
@media (min-width: 640px) {
  .ReviewForm_header__xiVcp {
    border-bottom: 1px solid #F8F7F7;
    padding-bottom: 12px;
    margin-bottom: 8px;
  }
}

.ReviewForm_headerTop__BmZHb {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}
@media (min-width: 640px) {
  .ReviewForm_headerTop__BmZHb {
    align-items: center;
    margin-bottom: 8px;
  }
}

.ReviewForm_title__f2LOX {
  font-weight: 500;
}

.ReviewForm_headerBottom__2Zkmi {
  display: flex;
  justify-content: space-between;
}

.ReviewForm_headerBottom__right__\\+f3ay .stars-rating {
  margin-left: auto;
}

.ReviewForm_assignees__P\\+aXy {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 8px;
}
.ReviewForm_assignees--more__wXl4C {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  grid-gap: 0;
}

.ReviewForm_assignee__vxj6G {
  display: flex;
  align-items: center;
}
.ReviewForm_assignee__info-container__jMDvy {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
@media (max-width: 640px) {
  .ReviewForm_assignee__info-container__jMDvy {
    flex-direction: column;
  }
  .ReviewForm_assignee__info-container__jMDvy .stars-rating {
    margin-left: 0;
  }
}

.ReviewForm_avatar__zFG3C {
  margin-right: 8px;
}

.ReviewForm_avatars__L6S54 {
  flex-shrink: 0;
  margin-right: 6px;
}

.ReviewForm_name__cR\\+yn {
  color: #54575C;
  word-break: break-word;
}
@media (min-width: 1200px) {
  .ReviewForm_name__cR\\+yn {
    font-size: 12px;
    line-height: 14px;
  }
}

.ReviewForm_stars__FIq\\+N {
  padding-top: 4px;
  width: auto;
  flex-shrink: 0;
  margin-left: auto;
  margin-right: 6px;
}
@media (min-width: 1200px) {
  .ReviewForm_stars__FIq\\+N {
    margin-right: 0;
  }
}

.ReviewForm_time__9-rWl {
  font-size: 12px;
  line-height: 14px;
  color: #7A808B;
  flex-shrink: 0;
  padding-top: 3px;
}
@media (min-width: 1200px) {
  .ReviewForm_time__9-rWl {
    align-self: flex-end;
    padding-top: 0;
  }
}

.ReviewForm_bot__ftsXw {
  display: none;
}
@media (min-width: 640px) {
  .ReviewForm_bot__ftsXw {
    display: block;
  }
}

.ReviewForm_label__MrvWS {
  font-size: 12px;
  line-height: 14px;
  display: block;
  color: #54575C;
  margin-bottom: 8px;
}

.ReviewForm_textarea__oAlOE {
  min-height: 30px;
}

.ReviewForm_footer__q755\\+ {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
  padding: 0 8px 8px;
}
@media (min-width: 640px) {
  .ReviewForm_footer__q755\\+ {
    background-color: #FAFAFA;
    padding: 12px;
  }
}

.ReviewForm_btn__D-mJG {
  padding-left: 24px;
  padding-right: 24px;
  margin-right: 8px;
}
.ReviewForm_btn__D-mJG:last-child {
  margin-right: 0;
}
.ReviewForm_btn__D-mJG img {
  right: 6px;
}

.ReviewForm_btnOpen__-2in3 {
  width: 56%;
  padding-left: 16px;
  padding-right: 16px;
}
@media (min-width: 576px) {
  .ReviewForm_btnOpen__-2in3 {
    width: 100%;
    padding-left: 24px;
    padding-right: 24px;
  }
}
@media (min-width: 1200px) {
  .ReviewForm_btnOpen__-2in3 {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Review/ReviewForm/ReviewForm.module.scss"],"names":[],"mappings":"AAAA;EACE,uDAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;AACF;AACE;EAHF;IAII,aAAA;EAEF;AACF;;AACA;EACE,mBAAA;AAEF;AAAE;EAHF;IAII,gCAAA;IACA,oBAAA;IACA,kBAAA;EAGF;AACF;;AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAGF;AADE;EALF;IAMI,mBAAA;IACA,kBAAA;EAIF;AACF;;AADA;EACE,gBAAA;AAIF;;AADA;EACE,aAAA;EACA,8BAAA;AAIF;;AACI;EACE,iBAAA;AAEN;;AAGA;EACE,aAAA;EACA,eAAA;EACA,aAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AADJ;AAGI;EALF;IAMI,sBAAA;EAAJ;EAGM;IACE,cAAA;EADR;AACF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,cAAA;EACA,iBAAA;AAJF;;AAOA;EACE,cAAA;EACA,sBAAA;AAJF;AAME;EAJF;IAKI,eAAA;IACA,iBAAA;EAHF;AACF;;AAMA;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAHF;AAKE;EAPF;IAQI,eAAA;EAFF;AACF;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAFF;AAIE;EAPF;IAQI,oBAAA;IACA,cAAA;EADF;AACF;;AAIA;EACE,aAAA;AADF;AAGE;EAHF;IAII,cAAA;EAAF;AACF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;AAAF;AAEE;EARF;IASI,yBAAA;IACA,aAAA;EACF;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;AACF;AACE;EACE,eAAA;AACJ;AAEE;EACE,UAAA;AAAJ;;AAIA;EACE,UAAA;EACA,kBAAA;EACA,mBAAA;AADF;AAGE;EALF;IAMI,WAAA;IACA,kBAAA;IACA,mBAAA;EAAF;AACF;AAEE;EAXF;IAYI,WAAA;EACF;AACF","sourcesContent":[".item {\r\n  box-shadow: 0px 5px 9px 0px #0000000D;\r\n  background-color: var(--white);\r\n  border-radius: 12px;\r\n}\r\n\r\n.main {\r\n  padding: 8px;\r\n\r\n  @media (min-width: 640px) {\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n.header {\r\n  padding-bottom: 4px;\r\n\r\n  @media (min-width: 640px) {\r\n    border-bottom: 1px solid #F8F7F7;\r\n    padding-bottom: 12px;\r\n    margin-bottom: 8px;\r\n  }\r\n}\r\n\r\n.headerTop {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 12px;\r\n\r\n  @media (min-width: 640px) {\r\n    align-items: center;\r\n    margin-bottom: 8px;\r\n  }\r\n}\r\n\r\n.title {\r\n  font-weight: 500;\r\n}\r\n\r\n.headerBottom {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.headerBottom__right {\r\n  :global {\r\n    .stars-rating {\r\n      margin-left: auto;\r\n    }\r\n  }\r\n}\r\n\r\n.assignees {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  grid-gap: 8px;\r\n\r\n  &--more {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: nowrap;\r\n    grid-gap: 0;\r\n  }\r\n}\r\n\r\n.assignee {\r\n  display: flex;\r\n  align-items: center;\r\n\r\n  &__info-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n\r\n    @media (max-width: 640px) {\r\n      flex-direction: column;\r\n\r\n      :global {\r\n        .stars-rating {\r\n          margin-left: 0;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.avatar {\r\n  margin-right: 8px;\r\n}\r\n\r\n.avatars {\r\n  flex-shrink: 0;\r\n  margin-right: 6px;\r\n}\r\n\r\n.name {\r\n  color: #54575C;\r\n  word-break: break-word;\r\n\r\n  @media (min-width: 1200px) {\r\n    font-size: 12px;\r\n    line-height: 14px;\r\n  }\r\n}\r\n\r\n.stars {\r\n  padding-top: 4px;\r\n  width: auto;\r\n  flex-shrink: 0;\r\n  margin-left: auto;\r\n  margin-right: 6px;\r\n\r\n  @media (min-width: 1200px) {\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n.time {\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n  color: #7A808B;\r\n  flex-shrink: 0;\r\n  padding-top: 3px;\r\n\r\n  @media (min-width: 1200px) {\r\n    align-self: flex-end;\r\n    padding-top: 0;\r\n  }\r\n}\r\n\r\n.bot {\r\n  display: none;\r\n\r\n  @media (min-width: 640px) {\r\n    display: block;\r\n  }\r\n}\r\n\r\n.label {\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n  display: block;\r\n  color: #54575C;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.textarea {\r\n  min-height: 30px;\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  border-bottom-right-radius: inherit;\r\n  border-bottom-left-radius: inherit;\r\n  padding: 0 8px 8px;\r\n\r\n  @media (min-width: 640px) {\r\n    background-color: #FAFAFA;\r\n    padding: 12px;\r\n  }\r\n}\r\n\r\n.btn {\r\n  padding-left: 24px;\r\n  padding-right: 24px;\r\n  margin-right: 8px;\r\n\r\n  &:last-child {\r\n    margin-right: 0;\r\n  }\r\n\r\n  img {\r\n    right: 6px;\r\n  }\r\n}\r\n\r\n.btnOpen {\r\n  width: 56%;\r\n  padding-left: 16px;\r\n  padding-right: 16px;\r\n\r\n  @media (min-width: 576px) {\r\n    width: 100%;\r\n    padding-left: 24px;\r\n    padding-right: 24px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    width: auto;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `ReviewForm_item__rJ7W6`,
	"main": `ReviewForm_main__K0R6V`,
	"header": `ReviewForm_header__xiVcp`,
	"headerTop": `ReviewForm_headerTop__BmZHb`,
	"title": `ReviewForm_title__f2LOX`,
	"headerBottom": `ReviewForm_headerBottom__2Zkmi`,
	"headerBottom__right": `ReviewForm_headerBottom__right__+f3ay`,
	"assignees": `ReviewForm_assignees__P+aXy`,
	"assignees--more": `ReviewForm_assignees--more__wXl4C`,
	"assignee": `ReviewForm_assignee__vxj6G`,
	"assignee__info-container": `ReviewForm_assignee__info-container__jMDvy`,
	"avatar": `ReviewForm_avatar__zFG3C`,
	"avatars": `ReviewForm_avatars__L6S54`,
	"name": `ReviewForm_name__cR+yn`,
	"stars": `ReviewForm_stars__FIq+N`,
	"time": `ReviewForm_time__9-rWl`,
	"bot": `ReviewForm_bot__ftsXw`,
	"label": `ReviewForm_label__MrvWS`,
	"textarea": `ReviewForm_textarea__oAlOE`,
	"footer": `ReviewForm_footer__q755+`,
	"btn": `ReviewForm_btn__D-mJG`,
	"btnOpen": `ReviewForm_btnOpen__-2in3`
};
export default ___CSS_LOADER_EXPORT___;
